module.exports = __webpack_public_path__ + "img/phone.a6335b55.png";